/* Article Table of Contents + social share — auto-built from the post content.
   Matches the behaviour of a typical news/blog article page (Educart-style):
   a "In This Article" jump list from the headings + share buttons. */
(function () {
  var ICONS = {
    whatsapp: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a9.9 9.9 0 00-8.5 15l-1.4 5 5.1-1.3A10 10 0 1012 2zm0 18a8 8 0 01-4.1-1.1l-.3-.2-3 .8.8-2.9-.2-.3A8 8 0 1112 20zm4.4-6c-.2-.1-1.4-.7-1.6-.8-.2-.1-.4-.1-.5.1l-.7.9c-.1.2-.3.2-.5.1a6.5 6.5 0 01-1.9-1.2 7.2 7.2 0 01-1.3-1.7c-.1-.2 0-.4.1-.5l.4-.4.2-.4v-.4l-.8-1.8c-.2-.5-.4-.4-.5-.4h-.5a1 1 0 00-.7.3 3 3 0 00-.9 2.2c0 1.3.9 2.5 1.1 2.7.1.2 1.9 2.9 4.6 4 .6.3 1.1.4 1.5.5.6.2 1.2.2 1.6.1.5-.1 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1l-.4-.2z"/></svg>',
    facebook: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.5 21v-8h2.7l.4-3h-3.1V8.1c0-.9.3-1.5 1.6-1.5h1.7V3.9c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3V10H7.3v3h2.6v8h3.6z"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 3h3l-6.6 7.5L21.7 21h-5.4l-4.2-5.5L7.2 21H4.2l7-8L2.7 3h5.5l3.8 5 4.3-5zm-1 16h1.7L8 4.7H6.2L16.5 19z"/></svg>',
    linkedin: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6.9 8.5H4V20h2.9V8.5zM5.4 4a1.7 1.7 0 100 3.4 1.7 1.7 0 000-3.4zM20 20v-6.3c0-3.1-1.7-4.6-3.9-4.6-1.8 0-2.6 1-3 1.7V8.5H10V20h2.9v-6c0-1.4.9-2.1 1.8-2.1s1.6.6 1.6 2.1V20H20z"/></svg>',
    link: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 007 0l3-3a5 5 0 00-7-7l-1 1"/><path d="M14 11a5 5 0 00-7 0l-3 3a5 5 0 007 7l1-1"/></svg>'
  };

  function slugify(s, i) {
    var out = (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
    return out || ('section-' + i);
  }

  function buildShare(url, title) {
    var eU = encodeURIComponent(url), eT = encodeURIComponent(title);
    var links = [
      { k: 'whatsapp', label: 'WhatsApp', href: 'https://wa.me/?text=' + eT + '%20' + eU },
      { k: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/sharer/sharer.php?u=' + eU },
      { k: 'x', label: 'X', href: 'https://twitter.com/intent/tweet?text=' + eT + '&url=' + eU },
      { k: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/sharing/share-offsite/?url=' + eU }
    ];
    var wrap = document.createElement('div');
    wrap.className = 'article-share';
    var lbl = document.createElement('span');
    lbl.className = 'article-share__label';
    lbl.textContent = 'Share:';
    wrap.appendChild(lbl);
    links.forEach(function (s) {
      var a = document.createElement('a');
      a.className = 'article-share__btn is-' + s.k;
      a.href = s.href;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.setAttribute('aria-label', 'Share on ' + s.label);
      a.innerHTML = ICONS[s.k];
      wrap.appendChild(a);
    });
    var copy = document.createElement('button');
    copy.type = 'button';
    copy.className = 'article-share__btn is-copy';
    copy.setAttribute('aria-label', 'Copy link');
    copy.innerHTML = ICONS.link;
    copy.addEventListener('click', function () {
      var done = function () {
        copy.classList.add('is-copied');
        setTimeout(function () { copy.classList.remove('is-copied'); }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () {});
      }
    });
    wrap.appendChild(copy);
    return wrap;
  }

  function buildTOC(headings) {
    if (headings.length < 3) return null;
    var nav = document.createElement('nav');
    nav.className = 'article-toc';
    nav.setAttribute('aria-label', 'Table of contents');
    var title = document.createElement('div');
    title.className = 'article-toc__title';
    title.textContent = 'In This Article';
    var ul = document.createElement('ul');
    ul.className = 'article-toc__list';
    var used = {};
    headings.forEach(function (h, i) {
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent, i);
        if (used[id]) id = id + '-' + i;
        h.id = id;
      }
      used[id] = true;
      var li = document.createElement('li');
      li.className = 'article-toc__item' + (h.tagName === 'H3' ? ' article-toc__item--sub' : '');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = (h.textContent || '').trim();
      li.appendChild(a);
      ul.appendChild(li);
    });
    nav.appendChild(title);
    nav.appendChild(ul);
    return nav;
  }

  function init() {
    var content = document.querySelector('.article-template__content');
    if (!content || content.getAttribute('data-tools-done')) return;
    content.setAttribute('data-tools-done', '1');

    var url = window.location.href;
    var h1 = document.querySelector('.article-template__title') || document.querySelector('h1');
    var title = (h1 && h1.textContent.trim()) || document.title;

    var headings = [].slice.call(content.querySelectorAll('h2, h3'));
    var share = buildShare(url, title);
    var toc = buildTOC(headings);

    var holder = document.createElement('div');
    holder.className = 'article-top-tools';
    holder.appendChild(share);
    if (toc) holder.appendChild(toc);
    content.insertBefore(holder, content.firstChild);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
